"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservabilityPipelineParseGrokProcessor = void 0;
/**
 * The `parse_grok` processor extracts structured fields from unstructured log messages using Grok patterns.
 */
class ObservabilityPipelineParseGrokProcessor {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return ObservabilityPipelineParseGrokProcessor.attributeTypeMap;
    }
}
exports.ObservabilityPipelineParseGrokProcessor = ObservabilityPipelineParseGrokProcessor;
/**
 * @ignore
 */
ObservabilityPipelineParseGrokProcessor.attributeTypeMap = {
    disableLibraryRules: {
        baseName: "disable_library_rules",
        type: "boolean",
    },
    id: {
        baseName: "id",
        type: "string",
        required: true,
    },
    include: {
        baseName: "include",
        type: "string",
        required: true,
    },
    inputs: {
        baseName: "inputs",
        type: "Array<string>",
        required: true,
    },
    rules: {
        baseName: "rules",
        type: "Array<ObservabilityPipelineParseGrokProcessorRule>",
        required: true,
    },
    type: {
        baseName: "type",
        type: "ObservabilityPipelineParseGrokProcessorType",
        required: true,
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=ObservabilityPipelineParseGrokProcessor.js.map